import { render } from "./ContentItem.vue?vue&type=template&id=6e8f4ac6&ts=true"
import script from "./ContentItem.vue?vue&type=script&lang=ts"
export * from "./ContentItem.vue?vue&type=script&lang=ts"

import "./ContentItem.vue?vue&type=style&index=0&id=6e8f4ac6&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__